import * as THREE from 'three'

/**
 * Creates a new Three.js scene.
 */
export const createScene = () => {
  const scene = new THREE.Scene()

  return scene
}
